export enum GreetingsCardsErrorType {
  FIELD_EMPTY = 'FIELD_EMPTY',
  CHAR_LIMIT_EXCEED = 'CHAR_LIMIT_EXCEED',
  LINES_LIMIT_EXCEED = 'LINES_LIMIT_EXCEED',
  SPL_CHARS_ENTERED = 'SPL_CHARS_ENTERED',
  EMOJIS_ENTERED = 'EMOJIS_ENTERED',
}
